import { Grid, useMediaQuery, Typography } from '@mui/material'
import FormLoginComponent from '../components/formLoginComponent'
import { useTheme } from '@mui/material/styles'
import backgroundImage from '../../../assets/bgLogin.png'
import backgroundImageSigma from '../../../assets/bgsigma.jpeg'
import backgroundImageMobile from '../../../assets/bgCetemin.jpg'
import { useEffect } from 'react'
import { useAuth } from '../../../shared/context/authContext'

export default function LoginView() {
    const theme = useTheme()
    const isMobile = useMediaQuery('(max-width: 600px)')

    const { isInitialized, loadingRedirectCallback, handleRedirectCallback, getLocalStorage } = useAuth();

    useEffect(() => {
        const handleAuth = async () => {
            if(!isInitialized) return;

            try{
                if(!loadingRedirectCallback){
                    const response = await handleRedirectCallback();
                    if(response){
                        getLocalStorage();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
        handleAuth();
    }, [isInitialized]);

    return (
        <Grid container>
            <Grid item size={{ xs: 12, md: 4.5 }} sx={{ backgroundColor: theme.palette.background.medium,
                //backgroundImage: isMobile ? `url(${backgroundImageMobile})` : "none",
                backgroundImage: isMobile ? `url(${backgroundImageSigma})` : "none",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                ":before": {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1
                }
             }} className='flex justify-center items-center h-screen'>
                <FormLoginComponent />
            </Grid>
           {!isMobile && <Grid  item size={{ xs: 12, md: 7.5}}  className='h-screen' sx={{ 
                //backgroundImage: `url(${backgroundImage})`, 
                backgroundImage: `url(${backgroundImageSigma})`,
                backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>

                
            </Grid>}
        
        </Grid>
    )
}